import { useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Cookies from 'js-cookie';
import jwt_decode from 'jwt-decode';
import axios from 'axios';

import { urlConfig } from '../../config/urlConfig';

import { ProfileContext } from '../../services/profile/profile.context';
import { AuthenticationContext } from '../../services/authentication/authentication.context';

const default_profile = '/icons/default_profile.png';

const useIslogin = () => {
  const history = useHistory();
  const { setUser, setProfileImage } = useContext(ProfileContext);
  const { setUserData, setUserPreferTime } = useContext(AuthenticationContext);

  const resetState = () => {
    setUser(null);
    setUserData(null);
    setUserPreferTime(null);
    setProfileImage({
      default: default_profile,
      value: '',
      error: '',
      blob: '',
    });
  };

  useEffect(() => {
    const abortController = new AbortController();
    const refresh_token = Cookies.get('refresh_token');
    let decode = '';

    if (refresh_token) {
      decode = jwt_decode(refresh_token);
      if (Date.now() / 1000 > decode.exp) {
        resetState();

        Cookies.remove('refresh_token', { path: '/' });
        Cookies.remove('access_token', { path: '/' });
        localStorage.clear();
        history.push({
          pathname: '/signin',
          state: history.location.pathname,
        });
      } else {
        // check account service is working?
        axios
          .post(urlConfig.refresh_token_url, {
            refresh: refresh_token,
            signal: abortController.signal,
          })
          .then((res) => {})
          .catch((err) => {
            resetState();
            Cookies.remove('refresh_token', { path: '/' });
            Cookies.remove('access_token', { path: '/' });
            localStorage.clear();
            history.push({
              pathname: '/signin',
              state: history.location.pathname,
            });
          });
        return () => abortController.abort();
      }
    } else {
      resetState();
      Cookies.remove('refresh_token', { path: '/' });
      Cookies.remove('access_token', { path: '/' });
      localStorage.clear();
      history.push({
        pathname: '/signin',
        state: history.location.pathname,
      });
    }
  }, [history]);
  return null;
};

export default useIslogin;
